import React from 'react'
import { Checkbox, Grid, TextField } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { ModalConfirmacao } from 'components'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <Checkbox checked fontSize="small" />

export const ModalDesvincularExaminador = (props) => {
  const {
    aberto,
    onClose,
    onConfirm,
    processando,
    listaExaminadores,
    examinadoresDesvincularSelecionado,
    setExaminadoresDesvincularSelecionado
  } = props

  const isDisabled = !examinadoresDesvincularSelecionado || examinadoresDesvincularSelecionado.length < 1

  return (
    <ModalConfirmacao
      aberto={aberto}
      onClose={onClose}
      onConfirm={onConfirm}
      processando={processando}
      disabled={isDisabled}
      titulo="Selecione o usuário que deseja desvincular do exame"
      confirmarLabel="Confirmar"
      confirmarColor="secondary"
      maxWidth="sm"
    >
      <div style={{ width: '100%', marginTop: '10px' }}>
        <Grid item xs={12}>
          <AutocompleteNative
            name="examinadoresDesvincularSelecionados"
            value={examinadoresDesvincularSelecionado}
            noOptionsText="Sem informações"
            options={listaExaminadores || []}
            multiple
            onChange={(event, newValue) => setExaminadoresDesvincularSelecionado(newValue)}
            required
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome?.toUpperCase() || ''} - ${option.cargo?.nome?.toUpperCase() || ''}`}
            renderOption={(option, { selected }) => (
              <>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {`${option.nome?.toUpperCase() || ''} - ${option.cargo?.nome?.toUpperCase() || ''}`}
              </>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Selecione"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </Grid>
      </div>
    </ModalConfirmacao>
  )
}
